import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import {
  setHtmlUnscrollable,
  setHtmlScrollable
} from '@jspartials/general-utils';

const selector = {
  button: {
    sizeVariant: '.js-button-size-variant',
    addToCart: '.js-button-add-to-cart',
    addToCartText: '.js-button-add-to-cart__text',
    openSizeVariants: '.js-button-open-size-variants',
    closeSizeVariants: '.js-button-close-size-variants'
  },
  wrapper: {
    sizeVariants: '.js-size-variants-wrapper'
  },
  text: {
    sizeVariantSelected: '.js-size-variant-selected'
  },
  sizeVariants: '.js-size-variants',
  selectSizeVariant: '.js-select-size-variant'
};

const element = {};

const listenSizeVariantButtons = () => {
  // Init elements
  initElements();

  // Listen size variant select
  if (element.selectSizeVariant) {
    listenDOMEvent(
      element.selectSizeVariant,
      'change',
      changeSelectSizeVariant
    );
  }

  // Listen size variant buttons
  element.button.sizeVariant.forEach((button) => {
    listenDOMEvent(button, 'click', clickOnSizeVariantButton);
  });

  // Listen open size variants button
  if (element.button.openSizeVariants) {
    listenDOMEvent(element.button.openSizeVariants, 'click', openSizeVariants);
  }

  // Listen close size variants button
  listenDOMEvent(window, 'click', function (event) {
    if (
      !event.target.closest(selector.button.openSizeVariants) &&
      !event.target.closest(selector.sizeVariants) &&
      element.wrapper.sizeVariants &&
      element.wrapper.sizeVariants.classList.contains(classes.is.open)
    ) {
      closeSizeVariants();
    }
  });
};

const initElements = () => {
  element.button = {
    sizeVariant: document.querySelectorAll(selector.button.sizeVariant) || [],
    addToCart: document.querySelector(selector.button.addToCart) || null,
    openSizeVariants:
      document.querySelector(selector.button.openSizeVariants) || null,
    closeSizeVariants:
      document.querySelector(selector.button.closeSizeVariants) || null
  };
  element.wrapper = {
    sizeVariants: document.querySelector(selector.wrapper.sizeVariants) || null
  };
  element.text = {
    sizeVariantSelected:
      document.querySelector(selector.text.sizeVariantSelected) || null
  };
  element.sizeVariants = document.querySelector(selector.sizeVariants) || null;
  element.selectSizeVariant =
    document.querySelector(selector.selectSizeVariant) || null;
};

const changeSelectSizeVariant = (event) => {
  const select = event.currentTarget;
  const value = select.value;

  enableAddToCartButton(value);
};

const clickOnSizeVariantButton = (event) => {
  const button = event.currentTarget;

  clearPreviousSelection();
  markCurrentSelection(button);
  enableAddToCartButton(button.dataset.pid);
  closeSizeVariants();
};

const clearPreviousSelection = () => {
  const selectedSizeVariantButtons = document.querySelectorAll(
    `${selector.button.sizeVariant}.is-selected`
  );

  selectedSizeVariantButtons.forEach((selectedSizeVariantButton) => {
    removeClassToElement(selectedSizeVariantButton, classes.is.selected);
  });
};

const markCurrentSelection = (button) => {
  const productId = button.dataset.pid;
  const sizeButtonsSelected = document.querySelectorAll(
    `${selector.button.sizeVariant}[data-pid="${productId}"]`
  );

  sizeButtonsSelected.forEach((button) => {
    addClassToElement(button, classes.is.selected);
  });

  updateTextForSizeVariantSelected(button.innerText);
};

const enableAddToCartButton = (productId) => {
  if (element.button.addToCart) {
    const addToCartText = element.button.addToCart.querySelector(
      selector.button.addToCartText
    );

    element.button.addToCart.dataset.pid = productId;
    element.button.addToCart.disabled = false;
    addToCartText.innerText = element.button.addToCart.dataset.messageAddToCart;
  }
};

const openSizeVariants = () => {
  if (element.wrapper.sizeVariants) {
    setHtmlUnscrollable();
    addClassToElement(element.wrapper.sizeVariants, classes.is.open);
    addClassToElement(element.wrapper.sizeVariants, classes.is.visible);
  }
};

const hideVariants = () => {
  removeClassToElement(element.wrapper.sizeVariants, classes.is.open);
  element.sizeVariants.removeEventListener('transitionend', hideVariants);
};

const closeSizeVariants = () => {
  listenDOMEvent(element.sizeVariants, 'transitionend', hideVariants);

  if (element.wrapper.sizeVariants) {
    setHtmlScrollable();
    removeClassToElement(element.wrapper.sizeVariants, classes.is.visible);
  }
};

const updateTextForSizeVariantSelected = (text) => {
  if (element.text.sizeVariantSelected) {
    element.text.sizeVariantSelected.innerText = text;
  }
};

export { listenSizeVariantButtons, closeSizeVariants };
